import React, { useState } from 'react';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { t } from '../../locales/i18n';
import { baseColors } from '../../themes/colors';
import styled from 'styled-components';

const EditWrapper = styled.span`
  i {
    color: ${baseColors.blue};
  }
`;
interface EditItemDialogProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
}
export default function EditItemDialog(props: EditItemDialogProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  const entityProps = { initialValues: { ...props } };
  return (
    <EditWrapper>
      <Modal trigger={<Icon name="edit" size="large" onClick={() => setOpen(true)} />} open={open}>
        <Modal.Header>{t('EDIT')}</Modal.Header>
        <Modal.Content>
          <props.form onClose={handleClose} submitted={handleClose} {...entityProps} />
        </Modal.Content>
      </Modal>
    </EditWrapper>
  );
}

// <Icon
// name="remove circle"
// onClick={() => confirmDialog(() => props.dispatch(deleteQueueAC(props._id)))}
// color="red"
// size="large"
// ></Icon>

// import React, { useState } from 'react';
// import { Modal, Button } from 'semantic-ui-react';
// import { t } from '../../locales/i18n';

// interface EditItemDialogProps {
//   // eslint-disable-next-line @typescript-eslint/no-explicit-any
//   form: any;
// }
// export default function EditItemDialog(props: EditItemDialogProps) {
//   const [open, setOpen] = useState(false);

//   const handleClose = () => setOpen(false);

//   const entityProps = { initialValues: { ...props } };
//   return (
//     <span>
//       <Modal trigger={<Button icon="edit" primary content={t('EDIT')} onClick={() => setOpen(true)} />} open={open}>
//         <Modal.Header>{t('EDIT')}</Modal.Header>
//         <Modal.Content>
//           <props.form onClose={handleClose} submitted={handleClose} {...entityProps} />
//         </Modal.Content>
//       </Modal>
//     </span>
//   );
// }
